//
//
//
//
//
//
//
//

	import SVGA from "svgaplayerweb";
	export default {
		name: 'boxstart',
		props: {
			start_svga: {
				type: String
			},
			animation_status: {
				type: Number,
				default: 0
			},
			vague: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				open: new Audio(require('../../../resources/audio/open.mp3'))
			}
		},	
		methods: {
			load() { //初始
				this.player = new SVGA.Player("#startCanvas")
				this.parser = new SVGA.Parser("#startCanvas")
				let new_svga = this.start_svga
				this.parser.load(new_svga, (videoItem) => {
					this.player.loops = 1
					this.player.clearsAfterStop = false
					
					this.player.setVideoItem(videoItem)
					this.player.stepToFrame(0, false)

					this.$emit('initial')
				})
			},

			stepToFrame() { //重置
				this.player.stepToFrame(0, false)
			},

			start() { //开始播放
				this.player.startAnimation()
				this.open.play()
				
				//监听帧数
				this.player.onFrame((i) => {
					if(i==50){
						this.$emit('finish')
					}
				})
				//结束回调
				// this.player.onFinished(() => {
				// 	this.$emit('finish')
				// })
			}
		},
		watch: {
			start_svga(v) {
				if (v) this.load()
			},
			animation_status(v){
				if(v !== 2){
					this.open.pause()
					this.open.load()
				}
			}
			
		}
	}
